import ProficiencyGroupsDesktop from "./ProficiencyGroupsDesktop";

export default ProficiencyGroupsDesktop;
export { ProficiencyGroupsDesktop };
